import { Button } from 'omakase';
import { Form, Formik, FormikErrors } from 'formik';
import { FormTextField, Grid } from 'ui';
import { isEmail } from '@tock/shared/utils/FormValidators';

const validate = (data: Fields) => {
  const errors: FormikErrors<Fields> = {};
  if (!isEmail(data.email)) {
    errors.email = 'Please enter a valid email';
  }
  return errors;
};

interface Props {
  onSubmit(values: Fields): void;
}

interface Fields {
  email: string;
}

const TransferRecipientForm: React.FC<Props> = ({ onSubmit }) => {
  return (
    <Formik<Fields> onSubmit={onSubmit} validate={validate} initialValues={{ email: '' }}>
      {({ isValid, isSubmitting, dirty }) => (
        <Form className="Form--default">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormTextField id="email" name="email" label="Email address" fullWidth />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="primary"
                size="large"
                type="submit"
                disabled={!isValid || isSubmitting || !dirty}
                fullWidth
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default TransferRecipientForm;
